<div id="toast-container" class="toast-bottom-right" *ngFor="let item of notifications">
  <div class="toast {{cssClass(item) }} d-flex align-itemss-center" aria-live="polite" style="display: block;">
      <!-- <button type="button" class="toast-close-button" role="button" (click)="removeNotification(item)">×</button> -->
      <div class="toast-message fw-bold">
          {{item.message}}
      </div>
  </div>
</div>
